import { ECrmType } from '@webtrader/core/enum/crm';
import request from '@webtrader/core/request';

export enum ECustomerType {
  CORPORATE = 3,
  INDIVIDUAL = 1
}

export interface ISignUpParams {
  customerType: ECustomerType;
  countryId: number;
  email: string;
  password: string;
  otp: string;
  crmType: ECrmType;
}

const signUp = (params: ISignUpParams) => {
  return request.post<string>('/api/auth/v1/register', params);
};

export default signUp;
